import { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/styles.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleNavLinkClick = () => {
    setMenuOpen(false);
  };

  // After navigating to "/", scroll to the hash target
  useEffect(() => {
    if (location.pathname === "/" && location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100); // small delay lets the page render first
      }
    }
  }, [location]);

  // Handle hash link clicks from any page
  const handleHashLink = (e, hash) => {
    e.preventDefault();
    setMenuOpen(false);

    if (location.pathname === "/") {
      // Already on home — just scroll
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Navigate to home first, then scroll via useEffect above
      navigate(`/#${hash}`);
    }
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="site-header">
      <div className="container nav" ref={navRef}>
        <a className="brand" href="/" aria-label="Zarkit home">
          <img src="/zarkit-z.png" alt="Zarkit logo" className="brand-logo" />
          <div className="brand-copy">
            <strong>Zarkit</strong>
            <span>Powered by Zarkit Group.</span>
          </div>
        </a>

        <button
          className="menu-toggle"
          aria-label="Toggle menu"
          aria-expanded={String(menuOpen)}
          aria-controls="navLinks"
          onClick={handleToggle}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav-links${menuOpen ? " open" : ""}`} id="navLinks">
          <a href="/" onClick={handleNavLinkClick}>
            Home
          </a>
          <a href="/about" onClick={handleNavLinkClick}>
            About
          </a>
          <a
            href="/#contact"
            onClick={(e) => handleHashLink(e, "contact")}
          >
            Contact
          </a>
          <a href="/privacy-policy" onClick={handleNavLinkClick}>
            Privacy Policy
          </a>
          <a href="/terms-conditions" onClick={handleNavLinkClick}>
            Terms &amp; Conditions
          </a>
        </nav>

        <a
          className="nav-cta"
          href="/#bulk-order"
          onClick={(e) => handleHashLink(e, "bulk-order")}
        >
          Book Bulk Order
        </a>
      </div>
    </header>
  );
}